import { version } from '../package.json';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { Image, Button } from 'react-bootstrap';
import { AlertList } from 'react-bs-notifier';

import { getURL, getGameInfoFromURL, inBlackList } from './Utils';

import './App.css';

import logo from './images/PLAYZIDO_logo_endemol.png';
import Games from './pages/Games';
import GameplayHistoryGenerator from './pages/GameplayHistoryGenerator/GameplayHistoryGenerator.jsx';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      position: 'top-right',
      alerts: [],
      timeout: 5000,
      newMessage: '',
      errorShownOnce: false,
      isGameplayHistoryGeneratorPageVisible: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    // You don't have to do this check first, but it can help prevent an unneeded render
    if (nextProps.launchError !== '' && !this.state.errorShownOnce) {
      this.generate(nextProps.launchError);
    }
  }

  generate(gameName) {
    this.setState({ errorShownOnce: true });

    const newAlert = {
      id: new Date().getTime(),
      type: 'danger',
      headline: 'Not found',
      //  timeout: 1000,
      message: gameName + ' is not available on this server'
    };

    this.setState({
      alerts: [...this.state.alerts, newAlert]
    });
  }

  onAlertDismissed(alert) {
    const alerts = this.state.alerts;

    // find the index of the alert that was dismissed
    const idx = alerts.indexOf(alert);

    if (idx >= 0) {
      this.setState({
        // remove the alert from the array
        alerts: [...alerts.slice(0, idx), ...alerts.slice(idx + 1)]
      });
    }
  }

  showGameplayHistoryGeneratorPage = () => {
    this.setState({
      isGameplayHistoryGeneratorPageVisible: true,
    })
  }

  hideGameplayHistoryGeneratorPage = () => {
    this.setState({
      isGameplayHistoryGeneratorPageVisible: false,
    })
  }

  openAdmin = function() {
    window.open(getURL() + '/backoffice', '_blank');
  };

  openDebug = function() {
    window.open(getURL() + '/debugger', '_blank');
  };

  render() {
    if (process.env.NODE_ENV === 'development') console.log('running in dev');
    else if (process.env.NODE_ENV === 'test') {
      console.log('running in test');
    } else {
      // console.log("i'm running in prod!");
    }

    const domainName = window.location.host.split('.')[0];

    return !getGameInfoFromURL() && !inBlackList() ? (
      <div className="App container">
        <AlertList
          position={this.state.position}
          alerts={this.state.alerts}
          timeout={this.state.timeout}
          onDismiss={this.onAlertDismissed.bind(this)}
        />

        <div className="page-header">
          <Image src={logo} responsive className="logoImage" />
          <p className="lead">
            The following games are available on: <strong>{domainName}</strong>
          </p>
        </div>

        <Games />
        
        <div className="footer">
          <Button 
            onClick={() => this.showGameplayHistoryGeneratorPage()} 
            bsStyle="link"
          >
            Gameplay History Generator
          </Button>
          <Button onClick={() => this.openAdmin()} bsStyle="link">
            Environment Backoffice
          </Button>
          <Button onClick={() => this.openDebug()} bsStyle="link">
            OGA General debug
          </Button>
          | {version}
        </div>
        {
          this.state.isGameplayHistoryGeneratorPageVisible && (
            <GameplayHistoryGenerator 
              goBack={this.hideGameplayHistoryGeneratorPage}
            />
          )
        }
      </div>
    ) : null;
  }
}

App.propTypes = {
  isFetching: PropTypes.bool,
  launchError: PropTypes.string,
  games: ImmutablePropTypes.list
};

function mapStateToProps(state) {
  const currentState = state.environment_information;

  const games = currentState.get('filteredGames');

  const launchError = currentState.get('launchError');

  return {
    currentState,
    games,
    launchError
  };
}

export default connect(
  mapStateToProps
)(App);



// WEBPACK FOOTER //
// ./src/App.js